var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkBox_head " },
    [
      _c("div", { staticClass: "search" }, [
        _c("span", { staticClass: "current_tit" }, [_vm._v("当前区域：")]),
        _c("div", { staticClass: "margin-right_20" }, [
          _c("span", [_vm._v(_vm._s(_vm.location.site))]),
          _vm.location.site
            ? _c("span", [
                _vm._v("附近" + _vm._s(_vm.toThousands) + "以内公司"),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("searchHeadCheckBox", {
        key: _vm.datekey,
        staticClass: "search-add-content",
        attrs: {
          searchType: "6",
          hideSome: false,
          placeholderStr:
            "请输入企业名称、手机号、产品名、经营范围、统一信用代码等，多关键词用空格隔开，如：“上海 珍岛”",
        },
        on: { "set-condition": _vm.setCondition },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }